import shiftAlarmRowUrl from './shiftAlarmRowComponent.html';

class ShiftAlarmRowCtrl {
  updateShiftAlarmTimeOption(option) {
    if (option.value === this.alarm.unit.value) {
      return;
    }

    this.alarm.unit = option;
    this.form?.$setDirty();
  }
}

export default {
  templateUrl: shiftAlarmRowUrl,
  controller: ShiftAlarmRowCtrl,
  controllerAs: 'ctrl',
  bindings: {
    alarm: '=',
    alarmsCount: '<',
    removeAlarm: '&',
  },
};
